export const TIMER_INITIAL_MIN = 15;
export const TIMER_INITIAL_SEC = 0;
